module.exports = __webpack_public_path__ + "img/9788925890241.a7579244.jpg";